import { defineComponent as _defineComponent } from 'vue'
import {
  beneficiaryTableFields,
  shortBeneficiaryTableFields,
} from 'ah-beneficiaries/src/models/beneficiaryTableFields';
import BeneficiaryListing from 'ah-beneficiaries/src/components/BeneficiaryListing.vue';
import BeneficiaryApproval from 'ah-beneficiaries/src/components/BeneficiaryApproval.vue';
import BeneficiaryEditModal from 'ah-beneficiaries/src/components/BeneficiaryEditModal.vue';
import SearchInput from '@/app/components/common/form/SearchInput.vue';
import BeneficiaryInfo from 'ah-beneficiaries/src/components/BeneficiaryInfo.vue';
import { Beneficiary, BeneficiaryCategory, BeneficiaryStatus, Client, PaginatedParams } from 'ah-api-gateways';
import { AnimatedListingWithSubViewState } from '@/app/components/common/animation/AnimatedListingWithSubView.vue';
import { editRoute } from 'ah-common-lib/src/helpers/route';
import SortSelector from 'ah-common-lib/src/common/components/SortSelector.vue';
import OnBehalfOf from 'ah-common-lib/src/onBehalfOf/OnBehalfOf';
import { useAuthStore } from '@/app/store/authModule';
import { computed, onBeforeMount, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';
import { getServices } from '@/app/services';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';


export default /*#__PURE__*/_defineComponent({
  __name: 'BeneficiariesView',
  props: {
  clientId: { type: String, required: false },
  beneficiaryId: { type: String, required: false, default: '' },
},
  setup(__props) {

const props = __props;



const requestManager = useRequestManager().manager;

const authStore = useAuthStore();

const route = useRoute();

const router = useRouter();

const services = getServices();

const beneficiaryApproval = ref<InstanceType<typeof BeneficiaryApproval>>();

const beneficiaryListing = ref<InstanceType<typeof BeneficiaryListing>>();

const sortAndPageParams = ref<Partial<PaginatedParams>>({ sort: 'name', sortDirection: 'ASC' });

const onBehalfOfClient = ref<Client>();

const animatedState = ref<AnimatedListingWithSubViewState | null>(null);

const query = ref<String>('');

const filter = computed(() => {
  return {
    query: query.value,
    category: authStore.isAgent ? BeneficiaryCategory.PARTNER_3RD_PARTY : BeneficiaryCategory.CLIENT_3RD_PARTY,
    status: [BeneficiaryStatus.APPROVED, BeneficiaryStatus.PENDING],
  };
});

const readonly = computed(() => route.meta?.readonly || false);
const isOBOAction = computed(() => !readonly.value && isAgent.value && onBehalfOfClient.value);
const isAgent = computed(() => authStore.isAgent);

onBeforeMount(() => {
  animatedState.value = {
    wideList: !props.beneficiaryId,
    showInfo: !props.beneficiaryId,
  };
});

function getOBOClient() {
  if (props.clientId) {
    requestManager.currentOrNew('loadClient', services.client.getClient(props.clientId)).subscribe((response) => {
      onBehalfOfClient.value = response;
    });
  }
}

watch(() => props.clientId, getOBOClient, { immediate: true });

const beneficiaryTableConfig = computed(() => {
  return { tableFields: beneficiaryTableFields };
});

const beneficiaryListingConfig = computed<any>(() =>
  !animatedState.value?.wideList ? shortBeneficiaryTableConfig : beneficiaryTableConfig
);

const shortBeneficiaryTableConfig = computed(() => {
  return { tableFields: shortBeneficiaryTableFields };
});

const fields = computed(() => beneficiaryTableConfig.value.tableFields);
const isPayments = computed(() => route.fullPath.includes('/payment'));

function goToBeneficiary(beneficiary?: Beneficiary) {
  const newRoute = editRoute(route, {
    params: {
      beneficiaryId: !beneficiary || props.beneficiaryId === beneficiary.id ? '' : beneficiary.id,
      clientId: props.clientId,
    } as any,
  });
  router.push(newRoute);
}

function onBeneficiaryAdded(beneficiary: Beneficiary) {
  onBeneficiaryUpdated();
  goToBeneficiary(beneficiary);
}

function onBeneficiaryUpdated() {
  beneficiaryListing.value!.loadData();
}

function onBeneficiaryDeleted() {
  goToBeneficiary();
  beneficiaryListing.value!.loadData();
}

function goBack() {
  router.push('/admin/activity/clients/obo/' + props.clientId);
}

return { __sfc: true,props, requestManager, authStore, route, router, services, beneficiaryApproval, beneficiaryListing, sortAndPageParams, onBehalfOfClient, animatedState, query, filter, readonly, isOBOAction, isAgent, getOBOClient, beneficiaryTableConfig, beneficiaryListingConfig, shortBeneficiaryTableConfig, fields, isPayments, goToBeneficiary, onBeneficiaryAdded, onBeneficiaryUpdated, onBeneficiaryDeleted, goBack, BeneficiaryListing, BeneficiaryApproval, BeneficiaryEditModal, SearchInput, BeneficiaryInfo, SortSelector, OnBehalfOf }
}

})